import { FunctionComponent } from 'react'

import { Box } from 'native-base'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'

type OnlineLearningIllustrationProps = {
  maxH?: number
}

export const OnlineLearningIllustration: FunctionComponent<OnlineLearningIllustrationProps> = ({
  maxH = 250
}) => (
  <Box {...{ maxH }}>
    <Svg width={251} height={250} viewBox="0 0 251 250" fill="none">
      <G clipPath="url(#clip0_8955_170210)">
        <Path
          d="M3.47021 212.67H247.8"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M233.81 152.88C233.73 151.28 233.61 149.62 233.48 147.93C233.42 147.19 233.35 146.44 233.28 145.68C232.74 139.99 231.93 133.92 231.01 128.03C230.8 128.24 230.44 123.31 230.18 123.49C224.84 127.21 221.94 137.67 219.03 143.24C216.54 148.01 212.2 151.31 209.53 155.93C208.59 157.55 207.53 159.12 206.36 160.6C206.38 161.47 206.21 162.35 205.82 163.15C200.43 174.14 188.26 178.38 176.99 174.34C174.2 173.34 171.44 171.66 169.94 169.26C167.65 169.36 165.45 168.49 163.44 166.09C163.36 166.11 163.29 166.14 163.22 166.17C163.32 166.23 163.42 166.29 163.51 166.35L163.41 166.4L158.3 168.76H158.29L152.68 171.37C152.08 171.11 151.45 170.85 150.81 170.57C144.7 167.96 136.87 164.61 129.36 161.42L124.25 159.24L122.92 158.67L120.78 157.76C118.67 156.87 116.68 156.02 114.83 155.24C112.35 154.18 110.15 153.26 108.4 152.52L104.06 160.78L104.05 160.81L77.3998 174.5L71.8198 177.37C72.4598 180.44 73.4298 183.4 74.6698 186.25C74.8098 186.57 74.9498 186.89 75.0998 187.2C75.6798 188.45 76.2998 189.68 76.9798 190.89C77.7898 192.33 78.6598 193.74 79.5798 195.11C82.1398 198.91 85.1198 202.44 88.2898 205.66L109.55 195.76H109.57L109.58 195.77L118.03 198.73L122.29 189.85H122.3L122.31 189.81L136.21 183.33C136.21 183.33 172.47 202.31 179.97 205.38C199.07 213.17 211.54 213.96 219.6 211.05C219.61 211.05 219.61 211.04 219.61 211.04C220.36 210.77 221.07 210.47 221.75 210.13C222.2 209.91 222.63 209.67 223.05 209.42C223.82 208.96 224.54 208.46 225.21 207.92C225.22 207.92 225.23 207.92 225.23 207.91C225.46 207.72 225.68 207.52 225.9 207.33C226.09 207.16 226.27 206.99 226.45 206.82C226.99 206.3 227.5 205.75 227.96 205.18C228.43 204.61 228.85 204.01 229.25 203.39C229.38 203.18 229.51 202.97 229.63 202.76C229.82 202.45 230 202.13 230.17 201.8C230.3 201.56 230.42 201.31 230.54 201.07C230.77 200.57 230.99 200.07 231.2 199.56C231.3 199.31 231.4 199.05 231.49 198.79C231.66 198.34 231.81 197.88 231.96 197.41C232.04 197.14 232.12 196.88 232.18 196.61C232.31 196.16 232.42 195.72 232.52 195.27C232.58 195.04 232.63 194.8 232.68 194.56C232.73 194.32 232.78 194.07 232.82 193.83C232.88 193.5 232.94 193.17 232.99 192.83C233 192.78 233.01 192.72 233.01 192.67C233.06 192.39 233.1 192.12 233.13 191.84C233.14 191.78 233.15 191.72 233.15 191.66C233.18 191.48 233.2 191.31 233.21 191.14C233.26 190.75 233.29 190.37 233.32 189.99C233.33 189.97 233.33 189.96 233.33 189.94C233.36 189.55 233.39 189.17 233.41 188.79V188.68C233.44 188.23 233.46 187.78 233.47 187.34C233.48 187.1 233.48 186.87 233.48 186.63C233.48 186.36 233.49 186.1 233.49 185.83C233.49 184.81 233.45 183.8 233.4 182.83C233.34 181.82 233.26 180.85 233.17 179.93C232.92 177.47 232.57 175.36 232.27 173.84C232.21 173.59 232.16 173.35 232.12 173.13C232.02 172.66 231.93 172.27 231.87 171.98C231.84 171.9 231.82 171.83 231.81 171.76C231.79 171.66 231.77 171.57 231.75 171.51C231.74 171.46 231.73 171.42 231.72 171.39C231.71 171.38 231.71 171.37 231.71 171.36V171.33L231.7 171.31C232.1 170.68 232.44 169.92 232.73 169.03C232.73 169.01 232.74 169 232.74 168.99C232.88 168.55 233.01 168.08 233.12 167.59C233.19 167.27 233.26 166.94 233.32 166.6C233.39 166.27 233.44 165.91 233.49 165.55C233.6 164.83 233.69 164.07 233.75 163.28C233.78 162.94 233.8 162.6 233.83 162.25C233.83 162.19 233.83 162.12 233.84 162.06C233.9 161.23 233.93 160.36 233.94 159.46C233.98 157.41 233.94 155.2 233.81 152.87V152.88Z"
          fill="#F3123C"
        />
        <Path
          d="M205.97 168.29C214.48 172.58 231.69 171.32 231.69 171.32"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M86.27 203.61C79.08 208.26 73.38 211.31 68.97 212.19H68.95C66.19 212.65 63.36 212.49 60.68 211.7C49.23 208.71 24.47 216.86 24.68 209.42C24.74 207.32 32.64 202.41 41.86 197.3C49.5 193.07 63.13 187.56 73.22 182.7C73.31 182.93 73.39 183.16 73.49 183.39C74.52 186.28 75.85 189.04 77.41 191.69C77.56 191.96 77.72 192.23 77.88 192.5C77.95 192.62 78.02 192.74 78.1 192.86C78.55 193.63 79.03 194.4 79.53 195.14C81.51 198.15 83.77 200.98 86.27 203.61Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M77.8802 192.499C76.1302 189.609 74.6302 186.569 73.4902 183.399C73.8502 184.369 74.2502 185.319 74.6702 186.259C74.8102 186.579 74.9502 186.899 75.1002 187.209C75.6802 188.459 76.3002 189.689 76.9802 190.899C77.2602 191.439 77.5602 191.969 77.8802 192.499V192.499Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M68.9501 212.189H68.9102"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M115.44 197.84C113.08 204.84 110.18 211.34 105.99 212.16C103.23 212.63 100.4 212.46 97.7102 211.67C90.5702 209.77 77.2002 212.97 68.9702 212.19C73.3802 211.31 79.0802 208.26 86.2702 203.61C83.7702 200.98 81.5102 198.15 79.5302 195.14H79.5602C82.1202 198.94 85.1102 202.47 88.2902 205.7L109.57 195.78H109.58L115.44 197.84Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M122.3 189.85L122.35 189.83L118.05 198.75L118.03 198.74L115.44 197.84L109.58 195.78L122.3 189.85Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M122.36 189.82V189.83H122.35L122.36 189.82Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M104.03 160.82L108.42 152.54"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M217.57 113.35V113.34"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M180.51 175.74L158.3 168.78"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M163.45 166.38L163.41 166.4"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M129.37 161.43L150.27 170.38C150.45 170.46 150.63 170.52 150.82 170.58"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M114.87 155.229L114.84 155.249L104.07 160.789L104.03 160.809L77.4 174.509L71.82 177.379L71.79 177.399C72.21 179.439 72.78 181.439 73.49 183.389"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M109.58 195.78L122.29 189.86L122.34 189.83H122.35L136.2 183.37C136.2 183.37 172.45 202.35 179.96 205.42C199.08 213.22 211.55 214 219.59 211.06V211.05C220.34 210.78 221.05 210.48 221.73 210.14C222.18 209.92 222.61 209.68 223.03 209.43C223.8 208.97 224.52 208.47 225.19 207.93C225.2 207.93 225.21 207.93 225.21 207.92C225.64 207.58 226.05 207.22 226.43 206.83C226.97 206.31 227.48 205.76 227.94 205.19C228.41 204.62 228.83 204.02 229.23 203.4C229.36 203.19 229.49 202.98 229.61 202.77C229.8 202.46 229.98 202.14 230.15 201.81C230.28 201.57 230.4 201.32 230.52 201.08C230.76 200.58 230.98 200.08 231.18 199.57C231.28 199.32 231.38 199.06 231.47 198.8C231.65 198.35 231.8 197.89 231.94 197.42C232.02 197.15 232.1 196.89 232.16 196.62C232.3 196.18 232.41 195.73 232.5 195.28C232.56 195.05 232.61 194.81 232.66 194.57C232.71 194.33 232.76 194.08 232.8 193.84C232.86 193.51 232.92 193.18 232.97 192.84C232.98 192.79 232.99 192.73 232.99 192.68C233.04 192.4 233.08 192.13 233.11 191.85C233.12 191.79 233.13 191.73 233.13 191.67C233.16 191.49 233.18 191.32 233.19 191.15C233.24 190.76 233.27 190.38 233.3 190C233.31 189.98 233.31 189.97 233.31 189.95C233.34 189.56 233.37 189.18 233.39 188.8V188.69C233.42 188.24 233.44 187.79 233.45 187.35C233.46 187.11 233.46 186.88 233.46 186.64C233.46 186.37 233.47 186.11 233.47 185.84C233.47 184.82 233.43 183.81 233.38 182.84C233.32 181.83 233.24 180.86 233.15 179.94C232.9 177.48 232.55 175.37 232.25 173.85C232.19 173.6 232.14 173.36 232.1 173.14C232 172.67 231.91 172.28 231.85 171.99C231.82 171.91 231.8 171.84 231.79 171.77C231.76 171.67 231.74 171.58 231.73 171.52C231.72 171.47 231.71 171.43 231.7 171.4C231.69 171.39 231.69 171.38 231.69 171.37C231.68 171.36 231.68 171.35 231.68 171.35C231.68 171.35 231.68 171.34 231.69 171.34C232.09 170.7 232.43 169.93 232.71 169.04C232.71 169.02 232.72 169.01 232.72 169C232.86 168.56 232.99 168.09 233.1 167.6C233.17 167.28 233.24 166.95 233.3 166.61C233.37 166.28 233.42 165.92 233.47 165.56C233.58 164.84 233.67 164.08 233.73 163.29C233.76 162.95 233.78 162.61 233.81 162.26C233.81 162.2 233.81 162.13 233.82 162.07C233.87 161.24 233.9 160.37 233.92 159.47C233.96 157.42 233.92 155.21 233.79 152.88C233.71 151.28 233.59 149.62 233.46 147.93C233.4 147.19 233.33 146.44 233.26 145.68C232.17 134.37 229.98 121.62 228.1 111.63H228.09"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M222.9 113.4C224.1 113.42 225.34 113.24 226.91 112.38"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M219.04 113.19C219.8 113.16 220.5 113.21 221.16 113.27"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M79.5601 195.13C79.0501 194.39 78.5701 193.63 78.1001 192.86"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M79.5601 195.13H79.5801L129.85 172.38C131.45 171.66 133.19 171.29 134.95 171.31C136.71 171.32 138.44 171.72 140.03 172.48C149.61 177.01 171.45 187.33 194.27 197.55C226.27 211.9 220.45 171.36 220.45 171.36C220.46 171.35 220.46 171.34 220.47 171.33C223.97 165.46 220.6 143.59 220.45 142.58L220.44 142.54"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M137.23 44.5898H66.6998C60.945 44.5898 56.2798 49.255 56.2798 55.0098V94.7798C56.2798 100.535 60.945 105.2 66.6998 105.2H137.23C142.985 105.2 147.65 100.535 147.65 94.7798V55.0098C147.65 49.255 142.985 44.5898 137.23 44.5898Z"
          fill="#F5F5F5"
        />
        <Path
          d="M147.65 55.96V95.22"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M87.54 105.2H66.25C63.6 105.2 61.06 104.14 59.19 102.27C57.32 100.4 56.27 97.86 56.27 95.21V59.21"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M56.2798 59.1696V54.5796C56.2798 51.9296 57.3298 49.3896 59.2098 47.5196C61.0798 45.6496 63.6198 44.5996 66.2698 44.5996H91.2398"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M100.01 44.5898H137.66C140.31 44.5898 142.85 45.6398 144.72 47.5098C146.59 49.3798 147.64 51.9198 147.64 54.5698V56.1598"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M85.5401 66.7901C85.2901 66.6501 85.0101 66.5801 84.7201 66.5801C84.4301 66.5801 84.1501 66.6601 83.9001 66.8001C83.6501 66.9401 83.4401 67.1501 83.3001 67.4001C83.1601 67.6501 83.0801 67.9301 83.0801 68.2201V81.6101C83.0801 81.9001 83.1501 82.1801 83.3001 82.4301C83.4401 82.6801 83.6501 82.8901 83.9001 83.0301C84.1501 83.1701 84.4301 83.2501 84.7201 83.2501C85.0101 83.2501 85.2901 83.1701 85.5401 83.0301L97.1601 76.3301C97.4101 76.1901 97.6101 75.9801 97.7601 75.7301C97.9001 75.4801 97.9801 75.2001 97.9801 74.9101C97.9801 74.6201 97.9001 74.3401 97.7601 74.0901C97.6201 73.8401 97.4101 73.6401 97.1601 73.4901L85.5401 66.7701V66.7901Z"
          stroke="#F3123C"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M111.67 80.4803C111.67 80.8503 111.61 81.2203 111.48 81.5703C111.34 81.9203 111.14 82.2303 110.88 82.5003C110.62 82.7703 110.31 82.9803 109.96 83.1203C109.62 83.2603 109.25 83.3403 108.87 83.3403C108.49 83.3403 108.13 83.2603 107.78 83.1203C107.44 82.9803 107.13 82.7603 106.86 82.5003C106.6 82.2303 106.39 81.9203 106.26 81.5703C106.12 81.2203 106.06 80.8503 106.06 80.4803V69.3903C106.06 69.0203 106.12 68.6503 106.26 68.3003C106.4 67.9503 106.6 67.6403 106.86 67.3703C107.12 67.1003 107.43 66.8903 107.78 66.7503C108.12 66.6103 108.49 66.5303 108.87 66.5303C109.25 66.5303 109.61 66.6103 109.96 66.7503C110.3 66.8903 110.61 67.1103 110.88 67.3703C111.14 67.6403 111.35 67.9503 111.48 68.3003C111.62 68.6503 111.68 69.0203 111.67 69.3903V80.4803V80.4803Z"
          stroke="#F3123C"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M121.31 80.4803C121.31 80.8503 121.25 81.2203 121.12 81.5703C120.98 81.9203 120.78 82.2303 120.52 82.5003C120.26 82.7703 119.95 82.9803 119.6 83.1203C119.26 83.2603 118.89 83.3403 118.51 83.3403C118.13 83.3403 117.77 83.2603 117.42 83.1203C117.08 82.9803 116.77 82.7603 116.5 82.5003C116.24 82.2303 116.03 81.9203 115.9 81.5703C115.77 81.2203 115.7 80.8503 115.71 80.4803V69.3903C115.71 69.0203 115.77 68.6503 115.9 68.3003C116.03 67.9503 116.24 67.6403 116.5 67.3703C116.76 67.1003 117.07 66.8903 117.42 66.7503C117.76 66.6103 118.13 66.5303 118.51 66.5303C118.89 66.5303 119.25 66.6103 119.6 66.7503C119.94 66.8903 120.25 67.1103 120.52 67.3703C120.78 67.6403 120.99 67.9503 121.12 68.3003C121.26 68.6503 121.32 69.0203 121.31 69.3903V80.4803V80.4803Z"
          stroke="#F3123C"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M90.42 101.33L139.29 89.6101C140.96 89.2101 142.68 90.0601 143.38 91.6201L161.26 131.64L199.91 146C201.65 146.65 201.73 149.08 200.03 149.83L154.84 169.85C153.43 170.47 151.83 170.49 150.41 169.9L106.45 151.61L88.28 105.46C87.59 103.71 88.61 101.76 90.43 101.32L90.42 101.33Z"
          fill="#F5F5F5"
        />
        <Path
          d="M185.04 140.321H185.05C186.75 142.871 188.61 145.521 190.52 148.081C190.53 148.091 190.54 148.091 190.54 148.101C190.39 148.331 190.23 148.571 190.08 148.811C192.35 147.061 194.37 143.681 195.76 141.721C197.59 139.151 199.5 136.621 201.22 133.961C201.52 132.361 201.91 130.701 202.02 129.121C201.92 129.301 201.82 129.481 201.71 129.661H201.7C201.7 129.661 201.68 129.631 201.67 129.621C200.31 128.011 198.88 126.231 197.77 124.791C197.52 124.481 197.3 124.171 197.08 123.881C196.91 123.661 196.76 123.451 196.62 123.261C195.81 123.561 195.01 123.891 194.23 124.241C193.97 124.361 193.71 124.481 193.45 124.611C193.19 124.731 192.93 124.861 192.68 124.991C192.44 125.111 192.21 125.231 191.97 125.361C191.43 125.651 190.89 125.961 190.36 126.281C190.23 126.371 190.09 126.451 189.95 126.531C189.42 126.861 188.89 127.211 188.38 127.571C188.02 127.821 187.66 128.081 187.3 128.351C185.78 129.481 184.35 130.731 183.03 132.091C182.91 132.211 182.8 132.331 182.69 132.451C182.62 132.511 182.55 132.581 182.49 132.651C182.02 133.141 181.56 133.661 181.12 134.181C181.45 134.721 181.8 135.261 182.14 135.811C183.03 137.251 184 138.761 185.04 140.311V140.321Z"
          fill="#F3123C"
        />
        <Path
          d="M190.57 147.99C189.68 146.82 188.83 145.67 188.03 144.53C185.85 141.51 183.91 138.61 182.14 135.82C181.8 135.27 181.45 134.73 181.12 134.19C181.56 133.67 182.02 133.15 182.49 132.66C182.55 132.59 182.61 132.52 182.68 132.45"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M194.23 124.25C193.97 124.37 193.71 124.49 193.45 124.62C193.19 124.74 192.93 124.86 192.68 125C192.44 125.12 192.21 125.24 191.97 125.37C191.43 125.66 190.89 125.97 190.36 126.29C190.22 126.37 190.09 126.45 189.95 126.54C189.42 126.87 188.89 127.22 188.38 127.58C188.01 127.83 187.65 128.09 187.3 128.36C185.78 129.49 184.35 130.74 183.03 132.1C182.91 132.21 182.79 132.33 182.68 132.45C180.23 128.29 177.11 124.45 173.54 121.2C167.65 116.17 170.97 116.43 173.54 117.56C176.37 118.8 182.56 122.41 182.15 119.36C181.45 117.66 180.82 115.93 180.27 114.18C180.27 114.17 180.26 114.17 180.26 114.16C179.7 112.36 179.21 110.54 178.8 108.7C178.23 106.88 177.81 105.01 177.55 103.12C177.45 102.44 177.38 101.75 177.32 101.07C176.72 93.9404 178.54 94.2004 180.83 100.58C186.33 115.93 191.67 120.55 194.23 124.25Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M183.73 122.91C183.17 121.74 182.64 120.56 182.15 119.36"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M180.64 114.921C180.52 114.671 180.4 114.431 180.27 114.181"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M180.26 114.16C179.02 111.73 177.56 109.37 176.05 107.11C175.28 105.85 172.98 102.38 172.41 101.57C169.77 97.8503 171.03 97.5703 171.67 97.9303C173.85 99.3803 175.83 101.13 177.55 103.12C177.81 105.01 178.23 106.88 178.8 108.7C179.21 110.54 179.7 112.36 180.26 114.16Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M177.61 103.19C177.61 103.19 177.57 103.14 177.55 103.12"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M182.73 132.53C182.73 132.53 182.7 132.48 182.69 132.46"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M182.15 119.36L182.12 119.21"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M201.68 129.62L188.02 144.54"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M224.74 113.82C222.58 113.12 220.74 113.2 220.66 113.18C220.12 113.14 218.67 113.21 218.48 113.23C218.44 113.24 218.4 113.24 218.36 113.25C218.23 113.25 218.1 113.28 217.97 113.29C217.94 113.29 217.91 113.29 217.88 113.3C217.77 113.31 217.67 113.32 217.57 113.34C217.48 113.36 217.38 113.38 217.29 113.41C217.27 113.41 217.24 113.42 217.21 113.43C217.06 113.46 216.9 113.49 216.74 113.54C216.6 113.57 216.46 113.61 216.31 113.66C216.12 113.71 215.93 113.78 215.73 113.85C215.66 113.87 215.58 113.9 215.51 113.93C215.37 113.98 215.23 114.02 215.09 114.08C215.07 114.09 215.06 114.1 215.04 114.11C214.78 114.23 214.53 114.35 214.28 114.48C214.03 114.61 213.78 114.74 213.54 114.88C213.29 115.02 213.05 115.16 212.81 115.31C212.55 115.47 212.29 115.64 212.04 115.82C211.84 115.94 211.65 116.08 211.46 116.22C211.01 116.55 210.57 116.9 210.15 117.26C209.91 117.46 209.67 117.68 209.44 117.89C209.24 118.08 209.05 118.27 208.85 118.47C207.51 119.84 206.36 121.39 205.42 123.1C205.01 123.81 204.51 124.7 203.93 125.74C203.83 125.96 203.73 126.18 203.59 126.4C203.47 126.6 203.34 126.8 203.21 127C202.75 127.82 202.25 128.7 201.7 129.66H201.69C201.69 129.66 201.67 129.63 201.66 129.62C201.64 129.6 201.63 129.58 201.61 129.56C199.85 132.31 198.04 135.02 196.32 137.8C194.36 140.96 193.16 144.88 190.93 147.79C190.71 148.07 190.48 148.32 190.24 148.54C189.19 150.16 188.09 151.82 186.94 153.52H186.92L161.9 141.17C159.71 140.09 157.61 139.65 155.69 139.72C154.52 139.75 153.42 139.98 152.4 140.37C152.25 140.43 152.1 140.48 151.96 140.54C151.79 140.61 151.63 140.68 151.47 140.76C151.3 140.84 151.13 140.93 150.97 141.02C150.79 141.11 150.62 141.2 150.46 141.31C150.33 141.39 150.2 141.47 150.07 141.57C146.1 144.3 143.96 149.63 145.11 154.84C145.11 154.84 155.26 161.22 163.51 166.35L163.41 166.4L162.75 166.71C162.88 166.84 163.02 166.96 163.14 167.1C167.29 168.22 170.52 172.06 174.54 173.66C179.1 175.48 184.01 176.35 188.76 177.51C189.04 177.58 189.3 177.65 189.56 177.72C192.39 177.15 195.01 176.11 197.74 175.38C198.66 174.65 200.08 174.24 200.9 173.49C204.48 170.23 207.05 166.22 209.4 162.07C214.85 152.43 220.62 143.31 225.61 133.42C226.93 130.81 228.38 128 229.63 125.17C231.62 120.66 229.42 115.32 224.73 113.81L224.74 113.82Z"
          fill="#F3123C"
        />
        <Path
          d="M155.7 139.731C154.53 139.761 153.43 139.99 152.41 140.38C152.26 140.44 152.11 140.491 151.97 140.551C151.8 140.621 151.64 140.69 151.48 140.77C151.31 140.85 151.14 140.94 150.98 141.03C150.8 141.12 150.63 141.21 150.47 141.32C150.34 141.4 150.21 141.481 150.08 141.581C147.22 143.501 145.29 146.791 144.85 150.431C139.99 147.57 139.14 145.64 138.16 140.09C137.77 137.9 137.45 136.711 135.55 136.581C122.56 135.701 120.95 133.13 123.24 132.81C127.25 132.23 129.91 131.62 132.47 131.03C119.27 127.2 119.11 123.75 121.5 124.2C125.46 124.96 129.68 125.84 133.29 126.42C133.27 126.41 133.26 126.411 133.24 126.401C119.4 120.651 117.82 115.851 120.14 116.761C122.81 117.801 126.63 119.371 130.21 120.761C122.51 115.711 124.89 115.22 128.51 116.79C133.28 118.85 143.27 122.98 143.98 123.56C144.45 123.93 145.06 124.701 145.74 125.661C147.56 128.231 149.8 132.191 150.6 133.551L151.41 134.941L151.56 135.2L151.63 135.32C152.43 136.691 153.45 137.92 154.66 138.96C154.87 139.11 155.27 139.431 155.7 139.731Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M138 123.491C136.2 123.021 133.29 121.961 130.21 120.761"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M132.48 131.03H132.47"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M136.19 126.84C135.29 126.73 134.26 126.57 133.24 126.4"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M151.41 134.94L150.6 133.55C149.8 132.19 147.56 128.23 145.74 125.66C145.55 124.1 145.61 122.38 145.85 120.83C145.98 120.09 146.22 119.37 146.54 118.91C147.31 117.76 148.51 118.23 149.24 124.05C149.55 127.75 150.23 131.42 151.41 134.94Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M145.76 125.85C145.75 125.79 145.74 125.73 145.74 125.66"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M151.49 135.19C151.46 135.11 151.43 135.02 151.41 134.94"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M130.35 120.851C130.3 120.821 130.25 120.791 130.21 120.761"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M134.1 130.65C133.56 130.77 133.02 130.89 132.48 131.03L132.78 131.11"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M217.88 113.3C217.78 113.31 217.68 113.33 217.57 113.35C217.48 113.37 217.39 113.39 217.29 113.41C217.27 113.41 217.24 113.41 217.21 113.43C217.06 113.46 216.9 113.49 216.74 113.54C216.6 113.57 216.46 113.61 216.31 113.66C216.12 113.71 215.93 113.78 215.73 113.85C215.66 113.87 215.58 113.9 215.51 113.93C215.36 113.98 215.2 114.04 215.04 114.11C214.78 114.23 214.53 114.35 214.28 114.48C214.03 114.61 213.78 114.74 213.54 114.88C213.29 115.02 213.05 115.16 212.81 115.31C212.55 115.47 212.29 115.64 212.04 115.82C211.84 115.94 211.65 116.08 211.46 116.22C211.01 116.54 210.57 116.89 210.15 117.26C209.91 117.46 209.67 117.68 209.44 117.89C209.24 118.08 209.05 118.27 208.85 118.47C207.49 119.84 206.32 121.41 205.37 123.14C204.52 124.61 203.3 126.84 201.7 129.66C199.61 133.34 196.88 138.05 193.51 143.41C192.58 144.88 191.6 146.41 190.57 147.99C190.56 148.02 190.54 148.05 190.52 148.08"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M163.41 166.4H163.42C171.03 171.15 173.4 172.55 175.59 173.66C177.02 174.39 178.43 175.01 179.78 175.51C179.8 175.52 179.81 175.52 179.83 175.53C192.35 180.22 201.62 175.95 207.35 165.71C208.2 164.19 216.06 150.33 220.45 142.58C222.2 139.5 223.4 137.38 223.4 137.38"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M242.77 76.4104C237.87 78.9204 232.04 77.3704 229.78 72.9604C227.53 68.5404 229.68 62.9304 234.59 60.4204C239.51 57.9004 245.32 59.4504 247.57 63.8704C249.83 68.2804 247.67 73.8904 242.77 76.4104Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M226.55 103.26C225.86 99.7502 225.28 97.0102 224.99 95.6802C224.43 93.3502 224.19 90.9502 224.25 88.5502C228.76 85.4602 224.79 80.2702 222.12 83.5302C221.75 84.0302 221.29 84.4502 220.75 84.7602C215.54 76.3902 211.67 76.6302 209.48 80.5102C212.06 74.1902 218.18 66.3102 231.77 75.5402C252.16 89.4102 225.84 90.1702 226.55 103.26Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M209.38 80.7707L209.47 80.5307C209.47 80.5307 209.47 80.5207 209.48 80.5107"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M228.11 111.631C227.99 111.721 227.87 111.801 227.76 111.881C227.46 112.071 227.18 112.241 226.91 112.381C226.18 112.751 225.4 113.031 224.59 113.201C224.03 113.321 223.47 113.381 222.9 113.401H222.84C222.34 113.391 221.85 113.341 221.34 113.291C221.28 113.291 221.22 113.281 221.16 113.271C220.99 113.251 220.83 113.221 220.66 113.181C220.12 113.141 219.58 113.141 219.04 113.191C218.86 113.191 218.67 113.211 218.48 113.231C218.32 113.241 218.15 113.261 217.97 113.291C217.94 113.291 217.91 113.291 217.88 113.301C217.77 113.311 217.67 113.321 217.57 113.341C217.84 112.031 218.02 110.711 218.09 109.371L222.85 102.411C221.49 103.861 219.87 105.031 218.06 105.861H218.05C211.96 108.241 208.59 101.981 207.69 94.7907C207.01 89.4107 207.67 83.7407 209.47 80.5307C209.47 80.5307 209.473 80.524 209.48 80.5107C211.67 76.6307 215.54 76.3907 220.75 84.7607C221.29 84.4507 221.75 84.0307 222.12 83.5307C224.79 80.2707 228.76 85.4607 224.25 88.5507C224.19 90.9507 224.43 93.3507 224.99 95.6807C225.28 97.0107 225.86 99.7507 226.55 103.261C227.04 105.741 227.58 108.611 228.11 111.631Z"
          fill="#F5F5F5"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M218.06 105.86C218.15 107.03 218.16 108.2 218.09 109.37"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M167.28 36.4704C159.92 36.3904 155.45 43.7804 159.34 49.4404L157.81 53.3304L161.71 51.7804C167.77 55.8604 176.42 51.9704 176.5 45.0504C176.54 40.3604 172.42 36.5304 167.28 36.4704Z"
          fill="#F3123C"
        />
        <Path
          d="M167.28 36.4704C159.92 36.3904 155.45 43.7804 159.34 49.4404L157.81 53.3304L161.71 51.7804C167.77 55.8604 176.42 51.9704 176.5 45.0504C176.54 40.3604 172.42 36.5304 167.28 36.4704V36.4704Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M183.26 60.0303V76.8403"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M191.67 68.4307H174.86"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M50.8302 114.16C50.8302 114.75 50.6602 115.32 50.3302 115.81C50.0002 116.3 49.5402 116.68 49.0002 116.9C48.4602 117.12 47.8602 117.18 47.2902 117.07C46.7202 116.96 46.1902 116.67 45.7702 116.26C45.3602 115.84 45.0702 115.32 44.9602 114.74C44.8502 114.16 44.9002 113.57 45.1302 113.03C45.3502 112.49 45.7302 112.03 46.2202 111.7C46.7102 111.38 47.2802 111.2 47.8702 111.2C48.2602 111.2 48.6502 111.28 49.0102 111.42C49.3702 111.57 49.7002 111.79 49.9702 112.06C50.2502 112.34 50.4602 112.66 50.6102 113.02C50.7602 113.38 50.8402 113.77 50.8302 114.16V114.16Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M14.2301 60.0302C14.2301 60.4402 14.1101 60.8302 13.8901 61.1702C13.6701 61.5102 13.3501 61.7702 12.9701 61.9202C12.6001 62.0802 12.1801 62.1202 11.7901 62.0402C11.3901 61.9602 11.0301 61.7702 10.7401 61.4802C10.4501 61.1902 10.2601 60.8302 10.1801 60.4302C10.1001 60.0302 10.1401 59.6202 10.3001 59.2502C10.4501 58.8802 10.7201 58.5602 11.0501 58.3302C11.3901 58.1102 11.7801 57.9902 12.1901 57.9902C12.4601 57.9902 12.7301 58.0402 12.9701 58.1402C13.2201 58.2402 13.4401 58.3902 13.6301 58.5802C13.8201 58.7702 13.9701 59.0002 14.0701 59.2402C14.1701 59.4802 14.2301 59.7602 14.2301 60.0202V60.0302Z"
          stroke="#404040"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_8955_170210">
          <Rect width={245.94} height={177.14} fill="white" transform="translate(3 36)" />
        </ClipPath>
      </Defs>
    </Svg>
  </Box>
)
